import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { TaskList } from "./components/TaskList/TaskList";
import "./main.scss";

interface ITask {
  id: number
  task: string
  done: boolean
}

export type TasksArr = ITask[]

window.addEventListener('load', () => {
  const loadingElement = document.querySelector('.loading') as HTMLElement;
  if (loadingElement) {
    loadingElement.style.display = "none";
  }
})

let tasks: TasksArr = restoreList();

const description = createRoot(document.getElementById("descr")!);

/* Сохранение */
function saveList(arr: TasksArr) {
  localStorage.setItem("taskList", JSON.stringify(arr));
}

/* Восстановление */

function restoreList() {
  const data = localStorage.getItem("taskList");
  if (!data) {
    return [];
  }
  return JSON.parse(data);
}

/* Рендер */
function renderList() {
  saveList(tasks);
  description.render(
    <StrictMode>
      <TaskList
        tasks={tasks}
        onDone={doneItem}
        onChangeTask={changeItem}
        onDelete={deleteItem}
        onDeleteComplited={deleteComplited}
        onSortList={sortList}
      />
    </StrictMode>
  );
}

renderList();

/* Добавление в массив */
function addTask(task: string) {
  tasks.push({ id: Date.now(), task, done: false });
  renderList();
}

/* Отмечено готово */
function doneItem(id: number) {
  tasks = tasks.map((task) =>
    task.id === id ? { ...task, done: !task.done } : { ...task }
  );
  renderList();
}

/* Логика кнопки изменить */
function changeItem(id: number) {
  tasks = tasks.map((task) => {
    if (task.id === id) {
      const a = prompt("Редактировать дело", task.task);
      if (a !== null) {
        return { ...task, task: a };
      } else {
        /* alert("Вы не изменили названия дела"); */
        return { ...task };
      }
    } else {
      return { ...task };
    }
  });
  renderList();
}

/* Удаление из массива */
function deleteItem(id: number) {
  if (confirm("Вы уверены?")) {
    tasks = tasks.filter((task) => task.id !== id);
  }
  renderList();
}

/* Удаление из массива выполненых  */
function deleteComplited() {
  tasks = tasks.filter((task) => !task.done)
  renderList()
}

/* Сортировка */
function sortList() {
  tasks = tasks.sort((a, b) => (a > b ? 1 : -1));
  renderList()
}

/* Форма */
const form = document.getElementById("form") as HTMLFormElement;
const formInput = form.querySelector(".form__input") as HTMLInputElement;
const formLabel = form.querySelector(".form__label") as HTMLInputElement;

form.addEventListener("submit", (e) => {
  e.preventDefault();
  const formInpValue = formInput.value.trim();
  if (formInpValue !== "") {
    form.reset();
    addTask(formInpValue);
  } else {
    formLabel.style.display = "block"
  }
});

formInput.addEventListener('input', () => {
  formLabel.style.display = "none"
})

/* аккардеон */
const accBtn = document.querySelector('.block__btn')
const descr = document.getElementById('descr')
accBtn?.addEventListener('click', () => {
  accBtn.classList.toggle('rotated')
  descr?.classList.toggle('hide')
})


